import React from 'react';
import { BsInstagram, BsGithub } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href='https://github.com/thops1925 ' >
        <BsGithub />

      </a>
    </div>
    <div>
      <a href='https://www.facebook.com/thops.lumen/' >
        <FaFacebookF />
      </a>
    </div>
    <div>
      <a href='https://www.instagram.com/thopzs/' >
        <BsInstagram />
      </a>
    </div>
  </div>
);

export default SocialMedia;